import { render, staticRenderFns } from "./产权需求详情_阶梯竞价版本_无socket.vue?vue&type=template&id=2d9872b7&scoped=true"
import script from "./产权需求详情_阶梯竞价版本_无socket.vue?vue&type=script&lang=js"
export * from "./产权需求详情_阶梯竞价版本_无socket.vue?vue&type=script&lang=js"
import style0 from "./产权需求详情_阶梯竞价版本_无socket.vue?vue&type=style&index=0&id=2d9872b7&prod&lang=css"
import style1 from "./产权需求详情_阶梯竞价版本_无socket.vue?vue&type=style&index=1&id=2d9872b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9872b7",
  null
  
)

export default component.exports